import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function createStore () {
    return new Vuex.Store({
        state: {
            isLogin: false,
            loginUserInfo: null,
            setsubsidies: null,
            callStatus: '', // 状态, idle, calling, connected
            isInviter: false,
            isAccepted: false,
            meetingUserIdList: [],
            muteVideoUserIdList: [],
            muteAudioUserIdList: [],
            btnText: "点击核验",
            hangupStatus:true,
            autioEle:null,
            btnFlag:false
        },
        mutations: {
            setsubsidiesparam (state, payload) {
                const { userId2,applicationNo,applyId,userName,applicationNoList,t } = payload
                state.setsubsidies = {
                    userId2,
                    applicationNo,
                    applyId,
                    userName,
                    applicationNoList,
                    t
                }
            },
            userLoginSuccess (state) {
                state.isLogin = true;
            },
            userLogoutSuccess (state) {
                state.isLogin = false;
                state.loginUserInfo = null;
            },
            setLoginUserInfo (state, payload) {
                const { userId, userSig } = payload;
                state.loginUserInfo = {
                    userId, userSig
                }
            },
            updatahangupStatus(state,hangupStatus){
                state.hangupStatus = hangupStatus
            },
            updateIsInviter (state, isInviter) {
                state.isInviter = isInviter;
            },
            updateCallStatus (state, callStatus) {
                state.callStatus = callStatus;
            },
            userJoinMeeting (state, userId) {
                if (state.meetingUserIdList.indexOf(userId) === -1) {
                    state.meetingUserIdList.push(userId);
                }
            },
            userJoinMeetingList (state, List) {
                state.meetingUserIdList.push(List);
            },
            userAccepted (state, isAccepted) {
                state.isAccepted = isAccepted;
            },
            userLeaveMeeting (state, userId) {
                const index = state.meetingUserIdList.findIndex(item => item === userId);
                if (index >= 0) {
                    state.meetingUserIdList.splice(index, 1);
                }
            },
            dissolveMeeting (state) {
                state.meetingUserIdList = [];
                state.isMuteVideoUserIdList = [];
                state.isMuteAudioUserIdList = [];
            },
            updateMuteVideoUserIdList (state, userIdList) {
                state.muteVideoUserIdList = userIdList;
            },
            updateMuteAudioUserIdList (state, userIdList) {
                state.muteAudioUserIdList = userIdList;
            },
            updataBtnText (state, text) {
                state.btnText = text
            },
            updataAutio (state, autioEle) {
                state.autioEle = autioEle
            },
            updataBtnFlag (state, btnFlag) {
                state.btnFlag = btnFlag
            }
            
        }
    });
}

const store = createStore();
export default store;
